import { Box, type BoxProps, styled } from '@mui/material'

import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { RADIUS } from '@/shared/styles/radii'
import { UI_FONT_SIZE, FONT_WEIGHT } from '@/shared/styles/typography'

interface Props extends Omit<BoxProps, 'onClick'> {
  index: number
  onJump?: (index: number) => void
}

const Styled = styled(Box)({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 16,
  minWidth: 16,
  padding: '0 4px',
  marginLeft: 4,
  borderRadius: RADIUS.sm,
  background: colorTokens.bg.muted,
  color: colorTokens.fg.muted,
  fontSize: UI_FONT_SIZE.micro,
  fontWeight: FONT_WEIGHT.medium,
  verticalAlign: 1,
  cursor: 'pointer',
  transition: 'background-color 120ms, color 120ms',
  '&:hover': {
    background: colorTokens.bg.emphasis,
    color: colorTokens.fg.default,
  },
})

export const Citation = ({ index, onJump, ...rest }: Props) => (
  <Styled
    component="span"
    role="button"
    tabIndex={0}
    onClick={() => onJump?.(index)}
    {...rest}
  >
    [{index}]
  </Styled>
)
